export { default } from './RedirectCancelButton';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/RedirectCancelButton/index.js